function flatCollection(state, action, type) {
    switch (action.type) {
        case `REQUEST_${type}`:
            return {
                isFetching: true,
                isError: false,
                data: {}
            };
        case `ERROR_${type}`:
            return {
                data: {},
                isError: true,
                isFetching: false
            };
        case `RECEIVE_${type}`:
            return {
                data: action.data.data,
                isFetching: false,
                isError: false
            };

        default:
            return state;
    }
}

export default flatCollection;
